export const isPlanExpired = (endDate) => {
    if (!endDate) return false;
    const today = new Date();
    const planEnd = new Date(endDate);
    return planEnd < today;
  };
  